import React from 'react';

import { useSsoRestriction } from '../../contexts';
import { InfoTooltip } from '../UserForm/components/InfoTooltip';

const SsoRestrictionContent: React.FC = () => (
  <p>
    This user signs in via single sign-on, so this detail is managed by their
    identity provider and is read-only here. Name, phone number, and order
    preferences remain editable.
  </p>
);

/**
 * Info icon + tooltip placed next to a section header to explain, inline, why
 * the section is read-only for single sign-on users.
 *
 * Reads the SSO restriction state from context, so it renders nothing unless
 * the user being edited is an SSO user. Callers drop it next to a header
 * unconditionally — no prop wiring required.
 */
export const SsoRestrictionTooltip: React.FC = () => {
  const { isSsoUser } = useSsoRestriction();

  if (!isSsoUser) {
    return null;
  }

  return (
    <InfoTooltip header="Read-only via SSO" content={SsoRestrictionContent} />
  );
};
